/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconDotsDiagonal2 = createReactComponent("dots-diagonal-2", "IconDotsDiagonal2", [
  ["path", { d: "M7 7m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", key: "svg-0" }],
  ["path", { d: "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", key: "svg-1" }],
  ["path", { d: "M17 17m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", key: "svg-2" }]
]);

export { IconDotsDiagonal2 as default };
//# sourceMappingURL=IconDotsDiagonal2.js.map
